'use strict';

exports.__esModule = true;
exports.default = {
    el: {
        colorpicker: {
            confirm: 'Oo naman',
            clear: 'Maaliwalas'
        },
        datepicker: {
            now: 'ngayon',
            today: 'ngayon',
            cancel: 'Kanselahin',
            clear: 'Maaliwalas',
            confirm: 'Oo naman',
            selectDate: 'Pumili ng petsa',
            selectTime: 'panahon ng pagpili',
            startDate: 'petsa ng pagsisimula',
            startTime: 'Oras ng pagsisimula',
            endDate: 'petsa ng pagtatapos',
            endTime: 'Oras ng Pagtatapos',
            prevYear: 'Nakaraang taon',
            nextYear: 'sa susunod na taon',
            prevMonth: 'noong nakaraang buwan',
            nextMonth: 'susunod na buwan',
            year: 'taon',
            month1: 'Enero',
            month2: 'Pebrero',
            month3: 'Marso',
            month4: 'Abril',
            month5: 'May',
            month6: 'Hunyo',
            month7: 'Hulyo',
            month8: 'Agosto',
            month9: 'Setyembre',
            month10: 'Oktubre',
            month11: 'Nobyembre',
            month12: 'Disyembre',
            // week: 'Linggo',
            weeks: {
                sun: 'araw',
                mon: 'isa',
                tue: 'dalawa',
                wed: 'tatlo',
                thu: 'Apat',
                fri: 'lima',
                sat: 'anim'
            },
            months: {
                jan: 'Enero',
                feb: 'Pebrero',
                mar: 'Marso',
                apr: 'Abril',
                may: 'May',
                jun: 'Hunyo',
                jul: 'Hulyo',
                aug: 'Agosto',
                sep: 'Setyembre',
                oct: 'Oktubre',
                nov: 'Nobyembre',
                dec: 'Disyembre'
            }
        },
        select: {
            loading: 'naglo-load',
            noMatch: 'Walang tugmang data',
            noData: 'walang data',
            placeholder: 'mangyaring pumili'
        },
        cascader: {
            noMatch: 'Walang tugmang data',
            loading: 'naglo-load',
            placeholder: 'mangyaring pumili',
            noData: 'Walang data'
        },
        pagination: {
            goto: 'Pumunta sa',
            pagesize: 'Artikulo / Pahina',
            total: '{total} mga item sa kabuuan',
            pageClassifier: 'Pahina'
        },
        messagebox: {
            title: 'pahiwatig',
            confirm: 'Oo naman',
            cancel: 'Kanselahin',
            error: 'Ang ipinasok na data ay ilegal!'
        },
        upload: {
            deleteTip: 'Pindutin ang delete key para tanggalin',
            delete: 'tanggalin',
            preview: 'tingnan ang larawan',
            continue: 'Magpatuloy sa pag-upload'
        },
        table: {
            emptyText: 'Walang data',
            confirmFilter: 'salain',
            resetFilter: 'i-reset',
            clearFilter: 'lahat',
            sumText: 'kabuuan'
        },
        tree: {
            emptyText: 'Walang data'
        },
        transfer: {
            noMatch: 'Walang tugmang data',
            noData: 'walang data',
            titles: ['Listahan 1', 'Listahan 2'],
            filterPlaceholder: 'Ipasok ang nilalaman ng paghahanap',
            noCheckedFormat: '{total} mga item sa kabuuan',
            hasCheckedFormat: '{checked}/{total} item ang napili'
        },
        image: {
            error: 'Nabigong mag-load'
        },
        pageHeader: {
            title: 'bumalik'
        },
        popconfirm: {
            confirmButtonText: 'Oo naman',
            cancelButtonText: 'Kanselahin'
        },
        empty: {
            description: 'Walang data'
        }
    }
};